var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 7.99851C21.9998 7.82003 21.9519 7.64486 21.8611 7.49118C21.7704 7.33749 21.6402 7.21089 21.484 7.12451L12.462 2.12451C12.3138 2.04283 12.1473 2 11.978 2C11.8088 2 11.6422 2.04283 11.494 2.12451L2.516 7.08451C2.36004 7.17087 2.23 7.29736 2.13935 7.45087C2.0487 7.60439 2.00073 7.77934 2.00043 7.95762C2.00012 8.1359 2.04748 8.31102 2.13761 8.46485C2.22773 8.61867 2.35734 8.74561 2.513 8.83251L11.535 13.8725C11.6835 13.956 11.851 13.9999 12.0214 14.0001C12.1917 14.0002 12.3593 13.9567 12.508 13.8735L21.486 8.8735C21.642 8.78678 21.7719 8.65991 21.8622 8.50605C21.9526 8.35219 22.0002 8.17695 22 7.99851ZM12.023 11.8535L5.06 7.96451L11.977 4.14251L18.941 8.0015L12.023 11.8535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.515 11.1255L12 15.8555L3.48498 11.1255L2.51398 12.8735L11.514 17.8735C11.6625 17.956 11.8296 17.9993 11.9995 17.9993C12.1694 17.9993 12.3365 17.956 12.485 17.8735L21.485 12.8735L20.515 11.1255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.515 15.1255L12 19.8555L3.48498 15.1255L2.51398 16.8735L11.514 21.8735C11.6625 21.956 11.8296 21.9993 11.9995 21.9993C12.1694 21.9993 12.3365 21.956 12.485 21.8735L21.485 16.8735L20.515 15.1255Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavUpload);
export default __webpack_public_path__ + "static/media/navUpload.994a419708bd24e4f57e6e97ec3f1052.svg";
export { ForwardRef as ReactComponent };